import 'cropperjs/dist/cropper.css';
import './style.scss';

import React, { useRef } from 'react';
import type { ReactCropperElement } from 'react-cropper';
import Cropper from 'react-cropper';
import { isMobile } from 'react-device-detect';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

import Icon from '@/components/icon';

const maxResolution = 4000000;
export const resizedImage = (height, width) => {
  let x = width;
  let y = height;
  const ratio = height / width;

  if (width * height > maxResolution) {
    x = Math.sqrt(maxResolution / ratio);
    y = maxResolution / x;
  }
  return { height: y, width: x };
};

function MediaCropper(props) {
  const cropperRef = useRef<ReactCropperElement>(null);

  const crop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper.getCroppedCanvas) {
      const canvas = cropper.getCroppedCanvas({ fillColor: '#fff' });
      const { width, height } = canvas;
      const resized = resizedImage(height, width);
      if (typeof props.onSave === 'function') {
        props.onSave(
          cropper.getCroppedCanvas({
            fillColor: '#fff',
            width: resized.width,
            height: resized.height,
          })
        );
      }
    }
  };

  const renderCropper = () => (
    <Cropper
      ref={cropperRef}
      src={props.src}
      crossOrigin="anonymous"
      style={{
        height: isMobile ? '100%' : '624px',
        width: '100%',
        maxHeight: isMobile ? '100vh' : '624px',
        maxWidth: '100vw',
      }}
      // Cropper.js options
      background={false}
      viewMode={1}
      // TODO Use state and app bar to allow user to change this between common types and freeform, unless circle is true
      aspectRatio={props.circle ? 1 : props.aspectRatio}
      guides
    />
  );

  return (
    <Modal
      isOpen={props.open}
      toggle={props.toggle}
      style={{ maxWidth: 724 }}
      fade
    >
      <div className="modal-header">
        <Button className="close" color="" onClick={props.onClose}>
          <Icon name="x" />
        </Button>
      </div>
      <ModalBody>
        <div className={props.circle ? 'circle-crop' : ''}>
          {renderCropper()}
        </div>
      </ModalBody>
      <ModalFooter>
        <div style={{ float: 'left' }}>
          <Icon
            name="rotate-ccw"
            style={{ cursor: 'pointer' }}
            onClick={() => cropperRef.current?.cropper.rotate(-45)}
          />
          <Icon
            name="rotate-cw"
            style={{ cursor: 'pointer' }}
            onClick={() => cropperRef.current?.cropper.rotate(45)}
          />
        </div>
        <Button color="light" disabled={props.saving} onClick={props.onClose}>
          Cancel
        </Button>
        <Button
          disabled={props.saving}
          onClick={crop}
          variant="contained"
          color="primary"
        >
          {props.saving ? 'Saving…' : 'Crop'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

MediaCropper.defaultProps = {
  aspectRatio: null,
};

export default MediaCropper;
